import { Dialog, DialogBody, DialogTitle, EditProps } from '@/components/base/dialog'
import { PencilIcon } from '@heroicons/react/24/solid'
import { Tabs } from '@/components/tabs'
import { Form as DetailsForm } from '@/components/client/edit_form'
import { useQuery } from '@apollo/client'
import { EditClientQuery } from './__generated__/edit_query'
import { Query } from './edit_query'
import { Inline as Loading } from '@/components/loading'

export const EditDialog = ({ id, open, setOpen }: EditProps) => {
  const tabs = [
    { name: 'Details', component: <DetailsForm id={id} />, icon: PencilIcon },
  ]

  const { data, loading } = useQuery<EditClientQuery>(Query, { variables: { filters: { idEq: id } } })

  return (
    <>
      <Dialog open={open} size="5xl" onClose={setOpen}>
        <DialogTitle>
          <div>{ loading || !data ? <Loading /> : data.clients.nodes[0].organisationName }</div>
        </DialogTitle>
        <DialogBody>
          <Tabs tabs={tabs} />
        </DialogBody>
      </Dialog>
    </>
  )
}
